import {ControlChange} from '../../../../core/models/control-change.model';
import {
  InfoExpertLink4DictionaryItem,
  VehicleService
} from '../../../../core/services/impl/section-services/vehicle-model/vehicle.service';
import {Component, HostListener, OnDestroy, OnInit, ViewChild, ViewChildren} from '@angular/core';
import {SectionBase} from '../../../components/section/section-base';
import {VehicleModelSectionConfig} from './vehicle-model-section.config';
import {VehicleModelStateService} from '../../../../core/services/impl/section-services/vehicle-model/vehicle-model-state.service';
import {VehicleModelConsts} from '../../../../core/consts/vehicle-model.consts';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {PredefinedValuesService} from '../../../../core/services/impl/section-services/predefined-values/predefined-values.service';
import {PredefinedValuesStateService} from '../../../../core/services/impl/section-services/predefined-values/predefined-values-state.service';
import {ApplicationStateService} from '../../../services/application-state.service';
import {VehicleDataModel} from '../../../../core/models/vehicle-data.model';
import {VehicleDataStateService} from '../../../../core/services/impl/section-services/vehicle-data/vehicle-data-state.service';
import {isCarOne, isEmbeddedInIframe, isKIOSKPOLIS, isMobile, isPromise, noop} from '../../../../core/utils/utils';
import {InsuranceDataEnum} from '../../../../core/consts/insurance-data.enum';
import {InsuranceDataStateService} from '../../../../core/services/impl/section-services/vehicle-data/insurance-data-state.service';
import {ConfigurationService} from '../../../../core/services/impl/configuration/configuration.service';
import {ElementVisibility} from '../../../../core/services/impl/configuration/internal-config';
import * as _ from 'lodash';
import {Validators} from '@angular/forms';
import {UrlParamsService} from '../../../../core/services/impl/url-params.service';
import {FieldType} from '../../../models/field-type';
import {FieldConfig} from '../../../models/field-config';
import {currentYear} from '../../../utils/time-utils';
import * as moment from 'moment';
import {ScrollHelper} from '../../../services/scroll-helper';
import {SelectComponent} from '../../../components/fields/ng-multiselect/select.component';
import {GoogleAnalyticsEventsService} from '../../../services/google-analytics-events.service';
import {GA4EventKey} from '../../../../core/consts/ga4-event-key.enum';
import {TranslateService} from '@ngx-translate/core';
import {ChipRemovalEvent} from '../../../components/chips-list/chips-list.component';
import {StepKey} from '../../../../core/enums/step-key.enum';
import {NavigateManagerService} from '../../../../core/services/navigate-manager.service';
import {AztecScannerService} from '../../../services/aztec-scanner.service';
import {MatDialogRef} from '@angular/material';
import {SelectDialogComponent} from '../../../components/dialogs/select-dialog/select-dialog.component';
import {MaterialYearPickerComponent} from '../../../components/fields/datepickers/material-datepicker/material-year-picker/material-year-picker.component';
import {SectionModeState, SectionsStateService} from '../../../services/sections-state.service';
import {SortOrder} from '../../../enums/sort-order.enum';
import {ApplicationContextService} from '../../../../core/services/impl/configuration/application-context.service';
import {DeviceService} from '../../../services/device.service';
import {NextOtherProductTheme} from '../../../components/next/next-other-products/next-other-products.component';
import {CompletedActionInfoData} from '../../../components/presentation/completed-action-info/completed-action-info.component';
import {SectionComponentKey} from '../../../../core/enums/components-keys';

@Component({
  selector: 'app-vehicle-model-section',
  templateUrl: './vehicle-model-section.component.html',
  styleUrls: ['./vehicle-model-section.component.scss']
})
export class VehicleModelSectionComponent extends SectionBase implements OnInit, OnDestroy {

  @ViewChild('productionYearField') productionYearField: MaterialYearPickerComponent;
  @ViewChildren(SelectComponent) selects;
  selectDialogRef: MatDialogRef<SelectDialogComponent> = null;
  OtherProductsTheme = NextOtherProductTheme;

  // aztecScannedCompletedActionInfoData: CompletedActionInfoData = {
  //   title: 'VEHICLE_MODEL_SECTION.AZTEC_SCANNED_COMPLETED_ACTION_INFO.title',
  //   buttonLabel: 'VEHICLE_MODEL_SECTION.AZTEC_SCANNED_COMPLETED_ACTION_INFO.buttonLabel'
  // };

  customerAgreementPhotoCompletedActionInfoData: CompletedActionInfoData = {
    title: 'VEHICLE_MODEL_SECTION.CUSTOMER_AGREEMENT_COMPLETED_ACTION_INFO.title',
    buttonLabel: 'VEHICLE_MODEL_SECTION.CUSTOMER_AGREEMENT_COMPLETED_ACTION_INFO.buttonLabel'
  };

  sectionClass = 'vehicle-model-section';
  public config: VehicleModelSectionConfig;
  public consts = {...VehicleModelConsts, ...InsuranceDataEnum};
  public link4DebugMode = false;
  private fieldsOrder: string[];
  private validateVersionEvent$;

  private supportedTemporaryDictionaries = [
    VehicleModelConsts.BRAND_CODE,
    VehicleModelConsts.PRODUCTION_YEAR,
    VehicleModelConsts.MODEL_CODE,
    VehicleModelConsts.ENGINE_CAPACITY,
  ];

  get aztecScannedFromQrCode(): boolean {
    return this.vehicleModelStateService.aztecScannedFromQrCode;
  }

  get aztecScannerInfoVisible(): boolean {
    if (this.vehicleModelStateService.isDiagnosticStationContext) {
      return this.deviceService.isMobileDevice && isKIOSKPOLIS() && !this.appStateService.aztecScannerActive && !this.aztecScannedFromQrCode;
    }
    return !this.isMobile && isKIOSKPOLIS() && !this.appStateService.aztecScannerActive;
  }

  get customerAgreementScanningMode(): boolean {
    return this.vehicleModelStateService.customerAgreementScanningMode;
  }

  get diagnosticStationProcessInfoVisible(): boolean {
    return this.vehicleModelStateService.isDiagnosticStationContext ? !this.deviceService.isMobileDevice && isKIOSKPOLIS() : false;
  }

  get aztecScannedCompletedActionInfoVisible(): boolean {
    if (isKIOSKPOLIS() && this.vehicleModelStateService.isDiagnosticStationContext) {
      return isKIOSKPOLIS() && !this.appStateService.aztecScannerActive && this.aztecScannedFromQrCode && !this.customerAgreementScanningMode;
    }
    return false;
  }

  get sectionsBellow(): boolean {
    return isKIOSKPOLIS() && this.navigateManagerService.currentStep.stepKey !== StepKey.FIRST_STEP_1;
  }

  get sectionVisible(): boolean {
    return !this.appStateService.aztecScannerActive && this.sectionFormVisible && !this.customerAgreementScanningMode;
  }

  get productionYearAsDatepicker(): boolean {
    return this.getFieldConfig(VehicleModelConsts.PRODUCTION_YEAR).type === FieldType.DateField;
  }

  get diagnosticStationScanView(): boolean {
    return !this.aztecScannedFromQrCode && this.vehicleModelStateService.isDiagnosticStationContext;
  }

  get sectionFormVisible(): boolean {
    if (this.vehicleModelStateService.isDiagnosticStationContext) {
      return this.aztecScannedFromQrCode;
    }
    return true;
  }

  constructor(public vehicleModelStateService: VehicleModelStateService,
              private sectionsStateService: SectionsStateService,
              private predefined: PredefinedValuesService,
              private predefinedState: PredefinedValuesStateService,
              public appStateService: ApplicationStateService,
              private vehicleDataStateService: VehicleDataStateService,
              private configuration: ConfigurationService,
              private insuranceDataStateService: InsuranceDataStateService,
              private urlParamsService: UrlParamsService,
              private navigateManagerService: NavigateManagerService,
              private googleAnalyticsService: GoogleAnalyticsEventsService,
              private translateService: TranslateService,
              private deviceService: DeviceService,
              public aztecScannerService: AztecScannerService,
              public vehicleService: VehicleService) {
    super();
    this.config = new VehicleModelSectionConfig(vehicleModelStateService, predefined);
    this.fieldsOrder = this.vehicleService.fieldsOrder;
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (!this.link4DebugMode) {
      this.link4DebugMode = event.getModifierState && event.getModifierState('Control') && event.keyCode === 76; // Ctrl + L
    }
  }

  ngOnInit() {
    this.sectionsStateService.createOrUpdateSectionState(SectionComponentKey.VEHICLE_MODEL, SectionModeState.EDIT);
    this.vehicleModelStateService.initChipsValues();
    this.setActiveFieldKey();
    this.initBean();
    this.initIsFieldDirtyBean();
    this.createConfig();
    this.buildForm();

    this.vehicleModelStateService.updateControlValueEvent.subscribe(data => {
      const {key, value} = data;
      this.getControl(key).setValue(value);
    });

    this.initFieldsState();
    this.initDictionaries();
    this.initializeCacheFields();
    this.handleVersionValidationEvent();
    this.handleRetriedDictionary();
  }

  ngOnDestroy(): void {
    this.validateVersionEvent$ ? this.validateVersionEvent$.unsubscribe() : noop();
  }

  get unknownRegistrationNumber(): boolean {
    return this.appStateService.state.unknownRegistrationNumber;
  }

  get infoexpertFieldVisible(): boolean {
    return isNotNullOrUndefined(this.vehicleData.vehicleCodeEurotax) && this.urlParamsService.isLoggedUserIdParam;
  }

  get vehicleServiceConfig() {
    return this.vehicleService.config;
  }

  get vehicleData(): VehicleDataModel {
    return this.vehicleModelStateService.vehicleData;
  }

  get firstFieldWithDictionary(): string {
    return this.fieldsOrder[0];
  }

  get hasEurotaxError() {
    return this.formFactoryService.errorsMap.get(this.formFactoryService.fieldConfig(this.consts.VEHICLE_CODE_EUROTAX, this.formConfig).fieldKey)
  }

  get shouldDisableRegistrationNumber(): boolean {
    return false;
    // return this.appStateService.state.unknownRegistrationNumber;
    // return this.appStateService.salesChannel === SalesChannel.YANOSIK && this.appStateService.state.calculationDataFromSession;
  }

  get infoExpertLink4Dictionary(): InfoExpertLink4DictionaryItem[] {
    return this.vehicleModelStateService.vehicleCodeInfoExpertLink4Dictionary;
  }

  get mainContentConfig() {
    return this.configuration.uiConfig.mainContentConfig;
  }

  get isMobile() {
    return isMobile();
  }

  get clearDataVisible() {
    if (isCarOne()) {
      return false;
    }
    return this.vehicleModelStateService.anyFirstStepDataFilled && !this.previewMode && !this.vehicleModelStateService.clearCalculationUsed &&
      (this.appStateService.sessionDataLoaded || this.appStateService.state.urlCalculationParamInserted);
  }

  get firstFieldWithoutValue(): string {
      for (let i = 0; i < this.fieldsOrder.length; i++) {
          let value;
          value = this.vehicleModelStateService.vehicleData[this.fieldsOrder[i]];
          if (!isNotNullOrUndefined(value)) {
              return this.fieldsOrder[i];
          }
      }
      return null;
  }

  get shouldScrollToSectionBeginning(): boolean {
    if (isEmbeddedInIframe()) {
      return !isMobile();
    }
    return true;
    // return !this.deviceService.isSafari;
  }

  get unknownRegistrationNumberVisible(): boolean {
    return !this.previewMode && !isKIOSKPOLIS();
  }

  get footerVisible(): boolean {
    return isKIOSKPOLIS() && !this.aztecScannedFromQrCode;
  }

  initBean() {
    this.bean = {
      ...this.vehicleModelStateService.vehicleData,
      ...this.vehicleModelStateService.vehicleModelState,
      ...this.insuranceDataStateService.insuranceData
    };

    if (this.bean.hasOwnProperty('registrationNumber')) {
      this.bean.unknownRegistrationNumber = this.bean.registrationNumber === this.vehicleModelStateService.unknownRegistrationNumberValue;
      this.bean.unknownRegistrationNumber ? this.bean.registrationNumber = null : noop();
    } else {
      this.bean.unknownRegistrationNumber = this.appStateService.state.unknownRegistrationNumber;
    }

    if (this.vehicleModelStateService.isDiagnosticStationContext) {
      this.bean.endInsuranceDate = this.appStateService.state.endInsuranceDate;
    }
  }

  initControlsChanges() {
    let controls: ControlChange[] = [];
    controls.push(
      {
        controlName: this.consts.ENGINE_POWER,
        behaviour: value => this.changeEnginePower(value)
      });

    if (this.vehicleModelStateService.isDiagnosticStationContext) {
      controls.push({
        controlName: this.consts.END_INSURANCE_DATE,
        behaviour: value => this.insuranceDataStateService.changeEndInsuranceDate(value)
      });
    } else {
      controls.push({
        controlName: this.consts.START_INSURANCE_DATE,
        behaviour: value => this.insuranceDataStateService.changeStartInsuranceDate(value)
      });
    }
    for (let i = 0; i < this.fieldsOrder.length; i++) {
      if (!this.vehicleServiceConfig[this.fieldsOrder[i]].isVersionField) {
        controls.push({
          controlName: this.fieldsOrder[i],
          behaviour: value => this.initBehaviour(value, this.fieldsOrder[i], this.fieldsOrder[i + 1])
        });
      } else { // behaviour for version fields
        controls.push({
          controlName: this.fieldsOrder[i],
          behaviour: value => this.initBehaviour(value, this.fieldsOrder[i])
        });
      }
    }

    this.handleControlsState(...controls);
  }

  changeEnginePower(value: string): void {
    this.vehicleModelStateService.changeEnginePower(value);
    if (isNotNullOrUndefined(value)) {
      this.initFieldBehaviour(VehicleModelConsts.VEHICLE_CODE_EUROTAX, this.getFilteredEurotaxDictionary());
    }
    this.openField(VehicleModelConsts.VEHICLE_CODE_EUROTAX);
    if (isNotNullOrUndefined(this.vehicleData.vehicleCodeEurotax)) {
      this.vehicleModelStateService.updateEnginePower(this.vehicleData.vehicleCodeEurotax);
    }
  }

  getFilteredEurotaxDictionary(): any[] {
    let items = this.vehicleServiceConfig[VehicleModelConsts.VEHICLE_CODE_EUROTAX].dictionary;
    const enginePower = this.vehicleModelStateService.vehicleModelState.enginePower;
    if (isNotNullOrUndefined(enginePower)) {
      items = items.filter(item => item.horsepower === enginePower);
    }
    return items;
  }

  clearFieldsDictionaries(fieldKey: string): void {
    this.vehicleServiceConfig[fieldKey].relatedFields.forEach(key => {
      if (this.getFieldConfig(key).type === FieldType.Select) {
        this.getFieldConfig(key).options['items'] = [];
      }

      if (this.vehicleServiceConfig[key].isVersionField) {
        this.vehicleService.forceExactCollectedCarsAmount = false;
      }

      let control = this.getControl(key);
      if (isNotNullOrUndefined(control.value)) {
        control.reset();
        this.bean[key] = control.value;
        this.vehicleModelStateService.vehicleData[key] = control.value;
        this.vehicleModelStateService.updateCalculation();
      }
    });
  }

  createConfig(): void {
    this.formConfig = this.config.createVehicleModelConfig();
  }

  markAsDirty(event) {
    this.predefinedState.isDirtyBean = event;
  }

  resolveElementVisibility(elementConfig: any): boolean {
    if (elementConfig && elementConfig.hasOwnProperty('visible')) {
      switch (elementConfig.visible) {
        case ElementVisibility.HIDDEN:
          return false;
        case ElementVisibility.ONLY_MOBILE:
          return this.isMobile;
        case ElementVisibility.ONLY_DESKTOP:
          return !this.isMobile;
        case ElementVisibility.VISIBLE:
          return true;
      }
    } else {
      return false;
    }
  }

  onEditModeChange() {
    this.vehicleModelStateService.updateChipsValues();
  }

  clearVehicleCalculationData(): void {
    this.vehicleModelStateService.resetFirstStepCalculationData();
    this.resetSection();
    this.vehicleModelStateService.clearVehicleDataEvent.emit();
    this.vehicleModelStateService.updateChipsValues();
    this.setActiveFieldKey();
  }

  onChipRemoval(event: ChipRemovalEvent): void {
    const { fieldKey, value } = event;
    this.sendFieldValueDeleteEvent(fieldKey, value);
    this.handleSetValueIfOnlyOneItem(fieldKey);
    if (fieldKey === VehicleModelConsts.ENGINE_POWER) {
      this.resetEnginePower();
      this.onChipRemoval({
        fieldKey: VehicleModelConsts.VEHICLE_CODE_EUROTAX
      });
      this.setEnginePowerDictionary();
    } else {
      this.getControl(fieldKey).setValue(null);
      this.clearFieldsDictionaries(fieldKey);
      this.vehicleModelStateService.valueChange(fieldKey, null);
      const items = fieldKey === VehicleModelConsts.VEHICLE_CODE_EUROTAX ? this.getFilteredEurotaxDictionary() : this.vehicleModelStateService.config[fieldKey].dictionary;
      this.initFieldBehaviour(fieldKey, items);
      this.vehicleModelStateService.setActiveFieldKey(fieldKey);
      this.vehicleService.initState(this.vehicleModelStateService.fieldsWithCodeParam);
    }
    if (this.isFieldBeforeGivenField(fieldKey, VehicleModelConsts.VEHICLE_CODE_EUROTAX)) {
      this.resetEnginePower();
    }
    if (fieldKey === VehicleModelConsts.VEHICLE_CODE_EUROTAX) {
      this.getControl(VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT).setValue(null);
      this.vehicleData.vehicleCodeInfoekspert = null;
      this.vehicleData.vehicleCodeInfoExpertLink4 = null;
      this.vehicleModelStateService.updateCalculation();
    }
    this.vehicleModelStateService.updateChipsValues();
  }

  handleSetValueIfOnlyOneItem(fieldKey: string): void {
    const fieldConfig: FieldConfig = this.getFieldConfig(fieldKey);
    if (fieldConfig.type === FieldType.Select && fieldConfig.select.setValueIfOnlyOneItem) {
      this.getFieldConfig(fieldKey).select.setValueIfOnlyOneItem = false;
      setTimeout(() => this.getFieldConfig(fieldKey).select.setValueIfOnlyOneItem = true, 0);
    }
  }

  resetEnginePower() {
    this.getControl(VehicleModelConsts.ENGINE_POWER).setValue(null);
    this.initFieldBehaviour(VehicleModelConsts.ENGINE_POWER, []);
  }

  createEnginePowerDictionary(eurotaxDictionary: any) {
    let enginePowerDictionary = [];
    if (eurotaxDictionary && eurotaxDictionary.hasOwnProperty('length') && eurotaxDictionary.length >= this.vehicleModelStateService.MIN_EUROTAX_VERSIONS_TO_SHOW_ENGINE_POWER) {
      enginePowerDictionary = _.uniq(eurotaxDictionary.map(item => item.horsepower))
          .sort((item1, item2) => parseInt(item1) - parseInt(item2));
      this.vehicleModelStateService.setActiveFieldKey(VehicleModelConsts.ENGINE_POWER);
      this.getControl(VehicleModelConsts.ENGINE_POWER).setValidators([Validators.required]);
    } else {
      this.getControl(VehicleModelConsts.ENGINE_POWER).clearValidators();
    }
    this.initFieldBehaviour(VehicleModelConsts.ENGINE_POWER, enginePowerDictionary);
    this.getControl(VehicleModelConsts.ENGINE_POWER).updateValueAndValidity();
  }

  onFieldOpened() {
    if (this.shouldScrollToSectionBeginning) {
      this.scrollToSectionBeginning();
    }
  }

  updateSelectDialogRef(dialogRef: any): void {
    this.selectDialogRef = dialogRef;
  }

  closeAztecScanner(scanningSuccess: boolean): void {
    this.aztecScannerService.closeAztecScanner(scanningSuccess);
  }

  onSectionDataPresentationAfterViewInit(): void {
    if (this.aztecScannerService.scanningSuccess && this.isMobile) {
      this.scrollToVehicleModelSectionContainer();
    }
  }

  scanCustomerAgreement(): void {
    this.submitSection();
    if (this.isSectionValid()) {
      this.vehicleModelStateService.customerAgreementScanningMode = true;
    }
  }

  onCustomerAgreementCaptureResult(data: string | null): void {
    this.vehicleModelStateService.customerAgreementScanningMode = false;
    if (isNotNullOrUndefined(data)) {
      this.vehicleModelStateService.saveCustomerAgreementPhoto(data);
    }
  }

  private sendFieldValueDeleteEvent(fieldKey: string, value: any) {
    if (isNotNullOrUndefined(value)) {
      const name = this.translateService.instant(this.getFieldConfig(fieldKey).caption);
      this.googleAnalyticsService.send(GA4EventKey.FIELD_VALUE_DELETE, {
        calculator_field_name_deleted: name,
        calculator_field_value_deleted: value,
      });
    }
  }

  private scrollToSectionBeginning() {
    if (this.isMobile) {
        this.scrollToVehicleModelSection();
    } else {
        setTimeout(() => this.scrollToVehicleModelSection(), 10);
    }
  }

  private scrollToVehicleModelSection(): void {
      (new ScrollHelper()).scrollIntoView('.vehicle-model-section', {behavior: 'smooth'});
  }

  private scrollToVehicleModelSectionContainer(): void {
    (new ScrollHelper()).scrollIntoView('.vehicle-model-section .container', {behavior: 'smooth'});
  }

  private initIsFieldDirtyBean() {
    this.isDirtyBean = this.predefinedState.isDirtyBean;
  }

  private initFieldBehaviour(fieldKey: string, items): void {
    this.setItems(fieldKey, items);
    this.setLoading(fieldKey, false);
    this.updateFieldStateAfterDictionaryChange(fieldKey, items);
  }

  private updateFieldStateAfterDictionaryChange(fieldKey, items): void {
    if (fieldKey === this.consts.VEHICLE_CODE_INFOEKSPERT) {
      if (items.length === 0) {
        this.disableField(fieldKey);
      } else {
        this.enableField(fieldKey);
      }
    }
  }

  private setItems(fieldKey: string, items: any): void {
    if (this.vehicleServiceConfig[fieldKey] && this.vehicleServiceConfig[fieldKey].sortOrder) {
      const sortOrder = this.vehicleServiceConfig[fieldKey].sortOrder;
      items = this.sortItems(items, sortOrder);
    }
    if (fieldKey === VehicleModelConsts.PRODUCTION_YEAR && this.productionYearAsDatepicker) {
      this.handleItemsForProductionYear(items);
    } else {
      this.getFieldConfig(fieldKey).options['items'] = items;
    }
  }

  private handleItemsForProductionYear(items: number[]): void {
    const minYear = Math.min(...items);
    const maxYear = Math.max(...items);
    this.getFieldConfig(VehicleModelConsts.PRODUCTION_YEAR).materialDateFieldConfig.minDate = minYear + '';
    this.getFieldConfig(VehicleModelConsts.PRODUCTION_YEAR).materialDateFieldConfig.maxDate = maxYear + '';

    const averageVehicleProductionYear = currentYear() - this.vehicleModelStateService.AVERAGE_VEHICLE_AGE;

    if (isNotNullOrUndefined(this.productionYearField)) {
      this.productionYearField.initDateRange();
      if (items.includes(averageVehicleProductionYear)) {
          this.productionYearField.updateStartAt(averageVehicleProductionYear);
      }
    } else {
        if (items.includes(averageVehicleProductionYear)) {
            this.getFieldConfig(VehicleModelConsts.PRODUCTION_YEAR).materialDateFieldConfig.startAt = () => averageVehicleProductionYear;
        }
    }
  }

  private disableFieldsAfterValueChange(fieldKey): void {
    const fieldIndex = this.fieldsOrder.indexOf(fieldKey);
    // disable all fields below next field
    for (let i = fieldIndex + 2; i < this.fieldsOrder.length; i++) {
      if (fieldKey !== this.vehicleService.lastFieldBeforeVersions || this.fieldsOrder[i] !== VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT) {
        this.disableField(this.fieldsOrder[i]);
      }
    }
  }

  private initFieldsState() {
    // disable registration number field for YANOSIK
    if (this.shouldDisableRegistrationNumber) {
      this.disableField(this.consts.REGISTRATION_NUMBER);
    }
    this.enableField(this.firstFieldWithDictionary);
    this.getFieldConfig(this.firstFieldWithDictionary).select.async = true;

    if (this.firstFieldWithoutValue) {
      const fieldIndex = this.fieldsOrder.indexOf(this.firstFieldWithoutValue);
      // do not disable IE field if Eurotax field is 1st field w/o value
      if (!this.vehicleServiceConfig[this.firstFieldWithoutValue].isVersionField) {
        for (let i = fieldIndex + 1; i < this.fieldsOrder.length; i++) {
          this.disableField(this.fieldsOrder[i]);
        }
      }
    }

    if (this.vehicleModelStateService.isRegistrationNumberUnknown) {
      this.appStateService.state.unknownRegistrationNumber = true;
    }
  }

  private setLoading(fieldKey: string, value: boolean): void {
    if (isNotNullOrUndefined(this.getFieldConfig(fieldKey).select)) {
      this.getFieldConfig(fieldKey).select.loadingEvent.next(value);
    } else if (isNotNullOrUndefined(this.getFieldConfig(fieldKey).materialDateFieldConfig)) {
      this.getFieldConfig(fieldKey).materialDateFieldConfig.loadingEvent.next(value);
    }
  }

  private initializeCacheFields() {
    this.vehicleModelStateService.initializedCacheDict.subscribe(initialized => {
      if (initialized) {
        this.fieldsOrder.forEach(fieldKey => {
          this.initFieldBehaviour(fieldKey, this.vehicleServiceConfig[fieldKey].dictionary);
        });

        this.initControlsChanges();

        if (this.firstFieldWithoutValue === VehicleModelConsts.VEHICLE_CODE_EUROTAX) {
          this.setEnginePowerDictionary();
        }

        if (!isNotNullOrUndefined(this.vehicleData.vehicleCodeInfoekspert)) {
          this.setInfoekspertVersionFromDictionary(this.vehicleServiceConfig[VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT].dictionary);
        }

        // this.fieldsOrder.forEach(fieldKey => this.resetValueIfDictionaryIsEmpty(fieldKey));
      }
    });
  }

  private setEnginePowerDictionary(): void {
    if (isPromise(this.vehicleServiceConfig[VehicleModelConsts.VEHICLE_CODE_EUROTAX].dictionary)) {
      this.vehicleServiceConfig[VehicleModelConsts.VEHICLE_CODE_EUROTAX].dictionary.then(items => this.createEnginePowerDictionary(items));
    } else {
      this.createEnginePowerDictionary(this.vehicleServiceConfig[VehicleModelConsts.VEHICLE_CODE_EUROTAX].dictionary);
    }
  }

  private resetValueIfDictionaryIsEmpty(fieldKey): void {
    if (this.getControl(fieldKey).value) {
      const dictionary = this.vehicleServiceConfig[fieldKey].dictionary;
      if (dictionary.hasOwnProperty('length')) { // dictionary is an array
        if (!dictionary.length) {
          this.getControl(fieldKey).reset();
          this.vehicleModelStateService.valueChange(fieldKey, null);
        }
      } else if (isPromise(dictionary)) { // dictionary is a promise
        dictionary.then(items => {
          if (!items.length) {
            this.getControl(fieldKey).reset();
            this.vehicleModelStateService.valueChange(fieldKey, null);
          }
        });
      }
    }
  }

  // --------- behavior after subscription -------------- //

  private initBehaviour(value, fieldKey: string, nextFieldKey?: string): void {
    if (isNotNullOrUndefined(value)) {
      if (fieldKey === VehicleModelConsts.PRODUCTION_YEAR && this.productionYearAsDatepicker) {
        const year = moment(value).year();
        value = year;
      }
      if (nextFieldKey) {
        this.vehicleModelStateService.setActiveFieldKey(nextFieldKey);
        this.setLoading(nextFieldKey, true);
        this.enableField(nextFieldKey);
        this.openField(nextFieldKey);
        if (this.vehicleServiceConfig[nextFieldKey].isVersionField) {
          // this.enableField(VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT);
          // this.setLoading(VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT, true);
          // const isInfoexpertDictionaryFilled = this.vehicleModelStateService.isDictionaryFilled(nextFieldKey);
          // if (isInfoexpertDictionaryFilled) {
          //   this.enableField(VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT);
          // }
        }
      }
      if (fieldKey === VehicleModelConsts.VEHICLE_CODE_EUROTAX) {
          this.vehicleModelStateService.setActiveFieldKey(null);
          this.enableField(VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT);
          this.setLoading(VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT, true);
      }
      this.clearFieldsDictionaries(fieldKey);
      this.disableFieldsAfterValueChange(fieldKey);

      this.vehicleModelStateService.valueChange(fieldKey, value);
      if (nextFieldKey) {
        this.vehicleModelStateService.config[nextFieldKey].dictionary
          .then(items => {
            if (isNotNullOrUndefined(items)) {
              this.initFieldBehaviour(nextFieldKey, items);

              if (nextFieldKey === VehicleModelConsts.VEHICLE_CODE_EUROTAX) {
                this.createEnginePowerDictionary(items);
                if (this.vehicleModelStateService.isFieldActive(VehicleModelConsts.ENGINE_POWER)) {
                  this.openField(VehicleModelConsts.ENGINE_POWER);
                }
              }
              // uncomment if both versions sources will be requested in one request
              // if (this.vehicleServiceConfig[nextFieldKey].isVersionField) {
              //   this.initFieldBehaviour(VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT, this.vehicleServiceConfig[VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT].dictionary);
              // }
            }
          });
      }
      if (fieldKey === VehicleModelConsts.VEHICLE_CODE_EUROTAX) {
        this.vehicleModelStateService.config[VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT].dictionary
          .then(items => {
            if (isNotNullOrUndefined(items)) {
              this.initFieldBehaviour(VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT, items);
              this.setInfoekspertVersionFromDictionary(items);
            }
          });
      }
      this.vehicleModelStateService.updateChipsValues();
    }
    if (fieldKey === VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT && !isNotNullOrUndefined(value)) {
      this.vehicleData.vehicleCodeInfoExpertLink4 = null;
      this.vehicleModelStateService.vehicleCodeInfoExpertLink4Dictionary = [];
    }
  }

  private setInfoekspertVersionFromDictionary(items: any[]): void {
    const versionValue = items.length ? items[0].code : null;
    this.getControl(VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT).setValue(versionValue);
  }

  private openField(fieldKey: string): void {
    setTimeout(() => {
      if (fieldKey === VehicleModelConsts.PRODUCTION_YEAR && this.productionYearAsDatepicker && isNotNullOrUndefined(this.productionYearField)) {
        this.productionYearField.open();
      } else {
        const selectComponent = this.selects.find((select: SelectComponent) => select.fieldConfig.fieldKey === fieldKey);
        if (selectComponent) {
          selectComponent.open();
        }
      }
    }, 0);
  }

  private handleRegistrationNumberChange(): void {
    this.vehicleModelStateService.registrationNumberEvent.subscribe(() => this.resetVersionFieldsState());
    this.vehicleModelStateService.versionsUpdateEvent.subscribe(() => {
      this.validateVersionFieldValue(VehicleModelConsts.VEHICLE_CODE_EUROTAX);
      this.validateVersionFieldValue(VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT);
      this.initFieldBehaviour(VehicleModelConsts.VEHICLE_CODE_EUROTAX, this.vehicleServiceConfig[VehicleModelConsts.VEHICLE_CODE_EUROTAX].dictionary);
      this.initFieldBehaviour(VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT, this.vehicleServiceConfig[VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT].dictionary);
    });
  }

  private handleVersionValidationEvent(): void {
    this.validateVersionEvent$ = this.vehicleModelStateService.validateVersionEvent.subscribe(versionKey => this.validateVersionFieldValue(versionKey));
  }

  /**
   * clear dictionaries and set loading for version fields after registration number change
   */
  private resetVersionFieldsState(): void {
    this.getFieldConfig(VehicleModelConsts.VEHICLE_CODE_EUROTAX).options['items'] = [];
    this.getFieldConfig(VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT).options['items'] = [];
    this.setLoading(VehicleModelConsts.VEHICLE_CODE_EUROTAX, true);
  }

  /**
   * reset control's value if selected version is no longer in updated dictionary
   */
  private validateVersionFieldValue(fieldKey: string): void {
    const control = this.getControl(fieldKey);
    if (isNotNullOrUndefined(control.value)) {
      const valueProperty = this.getFieldConfig(fieldKey).options['item'];
      const matchedItems = this.vehicleServiceConfig[fieldKey].dictionary.filter(item => item[valueProperty] === control.value);
      if (matchedItems.length === 0) { // selected item is no longer in dictionary
        control.reset();
        this.bean[fieldKey] = control.value;
        this.vehicleModelStateService.vehicleData[fieldKey] = control.value;
        this.vehicleModelStateService.updateCalculation();
      }
    }

  }

  private sortItems(items: any[], sortOrder: SortOrder): any[] {
    switch (sortOrder) {
      case SortOrder.ASCENDING:
        return items.sort();
      case SortOrder.DESCENDING:
        return items.sort((a, b) => (a > b ? -1 : 1));
      default:
        return items;
    }
  }

  private handleRetriedDictionary(): void {
    this.vehicleModelStateService.retriedDictionaryRequestEvent.subscribe(key => {
      const items = this.vehicleModelStateService.config[key].dictionary;
      if (isNotNullOrUndefined(items)) {
        this.initFieldBehaviour(key, items);
        if (this.vehicleServiceConfig[key].isVersionField) {
          this.initFieldBehaviour(VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT, this.vehicleServiceConfig[VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT].dictionary);
        }
      }
    });
  }

  private initDictionaries(): void {
    const initialized = this.vehicleModelStateService.initializedCacheDict.getValue();

    if (!initialized) { // set one-item, value based dictionaries if full dictionaries are not ready yet
      this.supportedTemporaryDictionaries.forEach(key => this.initDictionary(key));
    }
  }

  private initDictionary(key: string): void {
    let dictionary = [];
    switch (key) {
      case VehicleModelConsts.BRAND_CODE:
        if (this.vehicleData.brandCode && this.vehicleData.brandName) {
          dictionary = [{
            brandCode: this.vehicleData.brandCode,
            brandName: this.vehicleData.brandName
          }]
        }
        break;
      case VehicleModelConsts.PRODUCTION_YEAR:
        if (this.vehicleData.productionYear) {
          dictionary = [this.vehicleData.productionYear]
        }
        break;
      case VehicleModelConsts.MODEL_CODE:
        if (this.vehicleData.modelCode && this.vehicleData.modelName) {
          dictionary = [{
            modelCode: this.vehicleData.modelCode,
            modelName: this.vehicleData.modelName
          }];
        }
        break;
      case VehicleModelConsts.FUEL_CODE:
        if (this.vehicleData.fuelTypeCode && this.vehicleData['fuelTypeName']) {
          dictionary = [{
            fuelCode: this.vehicleData.fuelTypeCode,
            fuelName: this.vehicleData['fuelTypeName']
          }];
        }
        break;
      case VehicleModelConsts.ENGINE_CAPACITY:
        if (this.vehicleData.engineCapacity) {
          dictionary = [this.vehicleData.engineCapacity]
        }
        break;
      case VehicleModelConsts.VEHICLE_CODE_EUROTAX:
        if (this.vehicleData.vehicleCodeEurotax && this.vehicleData['vehicleNameEurotax']) {
          dictionary = [{
            code: this.vehicleData.vehicleCodeEurotax,
            name: this.vehicleData['vehicleNameEurotax']
          }];
        }
        break;
      case VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT:
        if (this.vehicleData.vehicleCodeInfoekspert && this.vehicleData['vehicleCodeInfoekspert']) {
          dictionary = [{
            code: this.vehicleData.vehicleCodeInfoekspert,
            name: this.vehicleData['vehicleNameInfoExpertLink4']
          }];
        }
        break;
    }

    if (dictionary.length) {
      if (this.getFieldConfig(key).select && this.getFieldConfig(key).select.async) {
        const dictionaryPromise = new Promise(resolve => resolve(dictionary));
        this.initFieldBehaviour(key, dictionaryPromise);
      } else {
        this.vehicleServiceConfig[key].dictionary = dictionary;
        this.initFieldBehaviour(key, dictionary);
      }
    }
  }

  private resetSection(): void {
    this.formConfig.fieldsConfig.forEach(fieldConfig => this.getControl(fieldConfig.fieldKey).reset());
  }

  private setActiveFieldKey(): void {
    this.vehicleModelStateService.setActiveFieldKey(this.firstFieldWithoutValue);
    if (!this.infoexpertFieldVisible && this.firstFieldWithoutValue === VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT) {
      this.vehicleModelStateService.setActiveFieldKey(null);
    }
  }

  private isFieldBeforeGivenField(fieldKey: string, givenFieldKey: string): boolean {
    if (this.fieldsOrder.includes(fieldKey)) {
      return this.fieldsOrder.findIndex(field => field === fieldKey) < this.fieldsOrder.findIndex(field => field === givenFieldKey);
    }
    return false;
  }

}
